export interface SettingsEventTypesRouter {
  goToDetail({ id, companyId }: { id: string; companyId: string }): void;
  goToEditDetail({ id, companyId }: { id: string; companyId: string }): void;
  goToCreate(): void;
  goToList(): void;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SettingsEventTypesRouter = Symbol('SettingsEventTypesRouter');
